export default __webpack_public_path__ + "static/desklocation01-6823adc87df90778ca455162c349a6ce.png";